export default "__VITE_ASSET__BwvRvC6J__"